<template>
    <div class="accordion" :class="{'accordion--active' : openState }">
        <button @click="toggle" class="accordion__button">
            {{title}}
            <span class="accordion__button-chevron">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-down" viewBox="0 0 16 16">
                    <path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708"></path>
                </svg>
            </span>
        </button>
        <div class="accordion__content-wrapper">
            <div class="accordion__content" :class="{ 'accordion__content--open' : openState}" v-html="content"></div>
        </div>
    </div>
</template>

<script setup>
    import {ref} from "vue";

    const props = defineProps({
        title: String,
        content: String,
        openState: {
            Type: Boolean,
            Default: false,
        },
    });

    const openState = ref(props.openState);

    const toggle = () => {
        openState.value = !openState.value;
    }

</script>